<form [formGroup]="form">
    <div class="table-flex text-xs w-100">
        <div class="tbody">
            <div class="trow">
                <!-- Checkbox -->
                <div class="tcell cell-checkbox shrink">
                    <app-form-checkbox [ariaLabelText]="admin.name" controlName="select" [size]="'lg'"></app-form-checkbox>
                </div>
                <!-- Name -->
                <div class="tcell cell-name grow pe-2">
                    <span [ngbTooltip]="admin.name" container="body" openDelay="500" class="text-oneline text-s" [ngClass]="{ 'font-bold': isSelected }">{{
                        admin.name
                    }}</span>
                </div>
                <!-- Country -->
                <div class="tcell cell-country grow pe-2">
                    <span [ngbTooltip]="admin.country" container="body" openDelay="500" class="text-oneline text-s">{{ admin.country }}</span>
                </div>
                <!-- Email -->
                <div class="tcell cell-email grow">
                    <div
                        class="copy-box w-100"
                        [ngbTooltip]="'v3-company-admin-support-popup-copy-email-adress-copied' | translate"
                        container="body"
                        [autoClose]="false"
                        triggers="manual"
                        [ngClass]="{ active: isSelected || onCopyHover || (copiedEmail$ | async) === admin.email }"
                        tooltipClass="tooltip-white"
                        #tooltipEmailCopied="ngbTooltip"
                    >
                        <span
                            [ngbTooltip]="admin.email"
                            container="body"
                            openDelay="500"
                            class="me-2 text-oneline font-medium text-s"
                            [ngClass]="{ 'font-bold': (copiedEmail$ | async) === admin.email }"
                            >{{ admin.email }}</span
                        >
                        <div
                            role="button"
                            tabbable
                            class="tw-ms-auto"
                            (spaceKeyUp)="copy(tooltipEmailCopied)"
                            (enterKeyUp)="copy(tooltipEmailCopied)"
                            (click)="copy(tooltipEmailCopied)"
                            (mouseleave)="onMouseLeave()"
                            (mouseenter)="onMouseEnter()"
                            (focus)="onMouseEnter()"
                            (blur)="onMouseLeave()"
                            [attr.aria-label]="'v3-company-admin-support-popup-copy-email-adress' | translate"
                            [ngbTooltip]="'v3-company-admin-support-popup-copy-email-adress' | translate"
                            container="body"
                            triggers="hover click"
                            buttonDataTest="copyEmailsButton"
                        >
                            <app-icon name="bookmarks" class="tw-w-4 tw-h-4"></app-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>

<ng-template #tipContent let-greeting="greeting">{{ greeting }}</ng-template>
